import { createRouter, createWebHistory } from 'vue-router';
import auth from '@/commons/authService';
import { MSEnum } from '@/commons/enumeration';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import routerPage from './routerPage';
import routerTask from './modules/routerTask';
import routerSetting from './modules/routerSetting';
import routerDashboard from './modules/routerDashboard';
import routerPrivacy from './modules/routerPrivacy';
import store from '@/stores/store';
import { showError } from '@/commons/globalMessage';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
const routes = [
  {
    path: ``,
    name: 'App',
    redirect: { name: 'dashboard' },
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      //default home
      ...routerTask,
      ...routerDashboard,
      ...routerSetting
    ]
  },
  ...routerPage, // Router logout login cho dev thi công
  ...routerPrivacy, // Router chính sách bảo mật
  {
    // Redirect to 403 page, if no permission
    path: '/403',
    component: () => import('@/pages/403.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    // Hết hạn sử dụng
    path: '/expire',
    component: () => import('@/pages/PageExpire.vue'),
    meta: {}
  },
  {
    // Chưa xác nhận thỏa thuận mua hàng
    path: '/agreement-expire',
    component: () => import('@/pages/PageAgreementExpire.vue'),
    meta: {}
  },
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/404.vue'),
    meta: {
      anonymous: true
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to, from) => {
  commonFn.unmask();
});

router.beforeEach((to, from, next) => {
  //khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  //do tình huông tải file js chậm
  //trong after sẽ ẩn mask loading đi
  //Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();

  //hide all popup
  //TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll();

  // Check explicit privacy paths first
  if (to.path === '/privacy' || to.path === '/thirdparty') {
    next();
    return;
  }

  //trang không authen
  if (to.meta.anonymous || to.path.includes('/privacy')) {
    next();
    return;
  }

  //kiểm tra authen -> fail redirect login
  if (!auth.isAuthenticated() && !to.path.includes('/privacy')) {
    commonFn.logoff();
  }

  //Phân quyền router
  let childs =
      routerDashboard.concat(
        { ...routerTask }[0].children,
        { ...routerSetting }[0].children
      ) ?? [],
    current = childs.find((i) => i.name == to.name);
  //Nếu trang nhập vào mà không có quyền
  if (
    current &&
    !commonFn.checkRoleEditable(current.subsystemCode, 'View') &&
    !current.isPermission
  ) {
    router.push('/403');
  }
  if (
    current &&
    current.name == 'handover' &&
    !store.state.context.User?.IsHandOverTask
  ) {
    router.push('/403');
  }

  //default
  next();
});

export default router;
